import api from 'service/api'

const dponetAPI = api.create('dponet', false)

const get = async ({ regulationId = '', ...params } = {}) => {
  return dponetAPI.get(`/backoffice/regulations/${regulationId}`, { params })
}

const create = async (data = {}) => {
  return dponetAPI.post('/backoffice/regulations', { regulation: data })
}

const update = async ({ regulationId = '', ...data }) => {
  return dponetAPI.patch(`/backoffice/regulations/${regulationId}`, {
    regulation: data,
  })
}

const regulations = { create, get, update }

export default regulations
